import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_RESPONSE__success extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.RESPONSE_SUCCESS;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    //do nothing
  }
}
